import React, { useEffect, useState } from "react"
import Loader from "../GlobalComponents/Loader"
import Search from "../GlobalComponents/Search"
import { PlusButton } from "../GlobalComponents/CommonComponents"
import { getAllSchedules, saveSchedule } from "../../services/scheduleServices"
import { showToast } from "../GlobalComponents/Toast"
import ScheduleModal from "./ScheduleModal"
import CalenderSection from "./CalenderSection"
import { BREAK, CLINICS, CONSULTANT, CREATE_APPOINTMENT, MEETING, OPERATION_THEATRE, ROOM_1, ROOM_2, SCHEDULE, SURGERY } from "../../utils/constants"
import { useDispatch } from "react-redux"
import { setActiveTab } from "../../redux/reducer/appReducer"
import ScheduleEdit from "./ScheduleEdit"
import { getFirstChars } from "../../utils/Helpers"
import { getUsersByRole, getUsersData } from "../../services/userServices"
import { Box, Switch, Typography } from "@mui/material"

function Schedule() {
  const formFields = {
    name: "",
    password: "",
    email: "",
    role: "",
    profileUrl: "",
    show: false,
  }

  // const [formData, setFormData] = useState(formFields);
  const [usersData, setUsersData] = useState([])
  const [isLoading, setIsLoading] = useState([])
  const [searchValue, setSearchValue] = useState("")
  const dispatch = useDispatch()
  const [allEvents, setAllEvents] = useState([])

  function handleSearchChange(e) {
    setSearchValue(e.target.value)
  }
  const [reloadData, setReloadData] = useState(false)

  async function getData() {
    setIsLoading(true)
    try {
      const data = await getUsersData({ searchValue })
      // console.log("usersData--23", data)

      if (data.error) {
        showToast("error", data.error)
        setUsersData([])
      } else {
        setUsersData(data.userDetails)
      }
    } catch (error) {
      console.log("getData error", error)
    }

    setIsLoading(false)
  }

  const [usersRoleData, setUsersRoleData] = useState([])

  async function getDataByUserRoles() {
    try {
      const doctorsResult = await getUsersByRole({
        role: [CONSULTANT],
        // role: [CONSULTANT, "Staff", "Admin"],
      })
      // console.log("usersData--23", doctorsResult)
      // setIsLoading(false);

      if (doctorsResult) {
        const doctorsData = doctorsResult?.userDetails?.map((each) => {
          let arr = []
          if (each?.firstName) arr.push(each.firstName)
          if (each?.lastName) arr.push(each.lastName)
          return { ...each, label: getFirstChars(arr) + " clinic", value: each }
        })

        setUsersRoleData(doctorsData)
      } else {
      }
    } catch (error) {
      console.log("getData error", error)
    }

    // setIsLoading(false);
  }

  // console.log("usersData--", { usersData, usersRoleData })

  useEffect(() => {
    getDataByUserRoles()
    getData()
    // getScheduleData("")
    dispatch(setActiveTab(SCHEDULE))
  }, [])

  const [openModal, setOpenModal] = useState(false)

  function onCloseModal() {
    setModalData((prev) => ({ ...prev, show: false, formData: formFields, isEditing: false }))
  }

  function onSubmitHandle() {
    getDataByUserRoles()
    getData()
    // console.log("onSubmitHandle", view)
    // getScheduleData("", view)
    setReloadData(true)
    onCloseModal()
  }

  async function onSubmit() {
    // setOpenModal(false);

    setIsLoading(true)
    try {
      const data = await saveSchedule({ searchValue })
      console.log("usersData--23", data)

      if (data.error) {
        showToast("error", data.error)
      } else {
        // setUsersData(data.userDetails);
        setModalData((prev) => ({ ...prev, show: false, formData: formFields }))

        // setRenderCalendar
      }
    } catch (error) {
      console.log("getData error", error)
      setModalData((prev) => ({ ...prev, show: false, formData: formFields }))
    }

    setIsLoading(false)
  }

  // let modalData = {};
  let fields = {
    title: CREATE_APPOINTMENT,
    show: false,
    formData: formFields,
    modalStyles: {
      width: "50%",
      maxWidth: "600px",
      // height: "100%",
      // maxHeight: "600px",
    }
  }

  const [modalData, setModalData] = useState(fields)
  function handleEdit(selectedData) {
    setModalData((prev) => ({
      ...prev,
      show: true,
      title: "Edit User",
      formData: selectedData,
    }))
  }

  let modalFields = {
    ...modalData,
    onClose: onCloseModal,
    onSubmit: onSubmitHandle,
  }

  const [renderCalendar, setRenderCalendar] = useState(false)
  const schedule = SCHEDULE[0].toUpperCase() + SCHEDULE.slice(1)
  const tabs = [schedule, CLINICS, OPERATION_THEATRE]

  const [view, setView] = useState(tabs[0])

  if (view === tabs[2]) {
    formFields.appointmentType = MEETING
  }

  const [tab, setTab] = useState(tabs[0]) // Default view is "month"

  const handleTab = (view) => {
    setTab(view)
  }
  // console.log("onSubmitHandle 123", {view, tab})


  // Fetching data (events)
  async function getScheduleData(
    searchKey,
    currentView,
    startDateObj,
    endDateObj,
    rooms = [ROOM_1, ROOM_2]
  ) {

    const intervalId = setTimeout(() => {
      setIsLoading(true)
    }, 10)
    
    try {

      if (!currentView) {
        currentView = view
      }

      if (!startDateObj) {
        const today = new Date();
        startDateObj = new Date(today.getFullYear(), today.getMonth(), 1);
      }

      if (!endDateObj) {
        const today = new Date();
        endDateObj = new Date(today.getFullYear(), today.getMonth() + 1, 1);
      }

      startDateObj.setDate(startDateObj.getDate() - 2)
      endDateObj.setDate(endDateObj.getDate() + 2)
      // console.log("onClickView", {currentView, startDateObj, endDateObj})

      const startYear = startDateObj.getFullYear();
      const startMonth = startDateObj.getMonth();
      const startDay = String(startDateObj.getDate()).padStart(2, '0');

      const endYear = endDateObj.getFullYear();
      const endMonth = endDateObj.getMonth();
      const endDay = String(endDateObj.getDate()).padStart(2, '0');

      // Create dates with time set to 00:00:00.000 and ensure they're on the 1st of each month
      const startDate = new Date(startYear, startMonth);
      startDate.setHours(0, 0, 0, 0);

      const endDate = new Date(endYear, endMonth);
      endDate.setHours(0, 0, 0, 0);

      // Format dates to YYYY-MM-DDT00:00:00.000Z
      const formattedStartDate = `${startDate.getFullYear()}-${String(startDate.getMonth() + 1).padStart(2, '0')}-${startDay}T00:00:00.000Z`;
      const formattedEndDate = `${endDate.getFullYear()}-${String(endDate.getMonth() + 1).padStart(2, '0')}-${endDay}T00:00:00.000Z`;

      const appointmentType = currentView === tabs[2] ? SURGERY : ""
      // console.log("getScheduleData", { formattedStartDate, formattedEndDate, currentView, appointmentType })
      const data = await getAllSchedules({
        searchKey,
        appointmentType,
        view: currentView,
        startDate: formattedStartDate,
        endDate: formattedEndDate,
        rooms
      })

      // console.log("usersData--23", { formattedStartDate, formattedEndDate })

      if (data?.scheduleDetails?.length) {
        let allEventsData = data.scheduleDetails.map((each) => {
          const start = new Date(each.start)
          const end = new Date(each.end)

          let patientName = ""

          if (each?.patientFirstName) {
            patientName = each?.patientFirstName
          }

          if (each?.patientLastName) {
            patientName += " " + each?.patientLastName
          }

          return {
            ...each,
            start,
            end,
            id: each._id,
            title: each?.clinicName || each?.title,
            label: each?.clinicName || each?.title,
            patientName,
          }
        })

        setAllEvents(allEventsData)
      } else {
        setAllEvents([])
      }
    } catch (error) {
      console.log("getData error", error)
    }

    if (intervalId) {
      clearTimeout(intervalId)
    }

    setIsLoading(false)
  }

  function onClickView(selectedView) {
    // console.log("onClickView", selectedView)
    // if (selectedView !== tabs[1] && view !== selectedView) {
    // getScheduleData("", selectedView)
    // }
    setView(selectedView)
  }

  // useEffect(() => {
  //     // if (props.isLoading === false) {
  //     getScheduleData("");
  //     setIsLoading(true);
  //     // }
  // }, [props.isLoading]);
  let title = CREATE_APPOINTMENT
  let isSurgeryAppointment = false
  if (view === tabs[2]) {
    title = "Surgery Appointment"
    isSurgeryAppointment = true
  }
  console.log("isSurgeryAppointment", view, isSurgeryAppointment)

  const onSelectEventCard = (data) => {
    if (data?.appointmentType === BREAK) {
      isSurgeryAppointment = false
    }
    setModalData((prev) => ({
      ...prev,
      show: true,
      title: data.title,
      isEditing: data.isEditing,
      formData: {
        ...prev.formData,
        appointmentType: (view === tabs[2]) && SURGERY,
        isSurgeryAppointment,
        ...data,
      }
    }))
  }

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        height: "99%",
        padding: "20px 40px",

        // border: "2px solid grey",
        // paddingTop: "20px",
        // padding: "40px 0px",
        // // width: "100%",
        // alignItems: "center",
        // // margin: "30px",
        // overflow: "auto",
        // padding: "0px 20px"
      }}
    >
      {isLoading && <Loader />}
      <div
        className="row-end"
        style={{ marginBottom: "20px", justifyContent: "space-between" }}
      >
        <div style={{ border: "0px solid blue" }}>
          <div
            className="custom-toolbar-views"
            style={{ border: "1px solid lightgrey", borderRadius: 4 }}
          >
            {tabs?.map((item, index) => (
              <button
                key={index}
                className={"toolbar_button_styles"}
                style={{
                  borderLeft: item === "month" && 0,
                  background: view === item ? "#fff" : "#ddd",
                }}
                onClick={() => onClickView(item)}
              >
                {item}
              </button>
            ))}
          </div>
          {/* <div className="custom-toolbar-views">
            <Box
              sx={{
                display: "flex",
                flexDirection: "row",
                alignItems: "center",
                border: "none",
              }}
            >
              <button
                style={{
                  background: "none",
                  border: "none",
                  cursor: "pointer",
                }}
                onClick={() => setEnableCliniView(false)}
              >
                <Typography fontWeight={600} color="#606061" fontSize={20}>
                  {tabs[0]}
                </Typography>
              </button>
              <Switch
                size="medium"
                onChange={() => setEnableCliniView(!enableClinicView)}
                checked={enableClinicView}
                sx={{
                  color: "red",
                  "& .MuiSwitch-thumb": {
                    backgroundColor: enableClinicView ? "#326ba8" : "#838385",
                  },
                }}
              />
              <button
                style={{
                  background: "none",
                  border: "none",
                  cursor: "pointer",
                }}
                onClick={() => setEnableCliniView(true)}
              >
                <Typography fontWeight={600} color="#326ba8" fontSize={20}>
                  {tabs[1]}
                </Typography>
              </button>
            </Box>
          </div> */}
        </div>


        <div style={{ display: "flex" }}>
          <PlusButton
            onClickPlus={() =>
              setModalData((prev) => ({
                ...prev,
                show: true,
                title,
                formData: {
                  ...prev.formData,
                  appointmentType: (view === tabs[2]) && SURGERY,
                  isSurgeryAppointment
                }
              }))
            }
          />
        </div>
      </div>

      {/*     
                {<UserCards usersData={usersData} handleEdit={handleEdit} />}
    
                {modalData.show && <UserForm {...modalData} />} */}

      {/* <div style={{ height: "80%", border: "2px solid blue", overflowY: "auto" }}> */}
      <div className="center-container">
        {(view === tabs[1]) ? (
          <ScheduleEdit allEvents={allEvents} usersRoleData={usersRoleData} />
        ) : (
          <>
            <CalenderSection
              isLoading={modalData.show}
              allEvents={allEvents}
              getScheduleData={getScheduleData}
              onSelectEventCard={onSelectEventCard}
              reloadData={reloadData}
              setReloadData={setReloadData}
              view={view}
            />
          </>
        )}
      </div>

      {modalData.show && <ScheduleModal {...modalFields} />}
    </div>
  )
}

export default Schedule
